import { render, staticRenderFns } from "./add_folder_or_document_dropdown.vue?vue&type=template&id=27516ed3"
import script from "./add_folder_or_document_dropdown.vue?vue&type=script&lang=js"
export * from "./add_folder_or_document_dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports